export const componentNames = {
  BasicDetails: 'Basic Details',
  Education: 'Education',
  Address: 'Address',
  DigitalAddress: 'Address',
  CompanyCheck: 'Company Check',
  Criminal: 'Criminal',
  CreditCheck: 'Credit Check',
  CibilCheck: 'Cibil Check',
  CvValidation: 'CV Validation',
  DatabaseCheck: 'Database Check',
  DirectorshipCheck: 'Directorship',
  DrugTest: 'Drug Test',
  Employment: 'Employment',
  GapVerification: 'Gap Verification',
  Identification: 'Identification',
  PoliceVerification: 'Police Verification',
  Reference: 'Reference',
  SocialMedia: 'Social Media',
  UanCheck: 'UAN Check',
  BankStatement: 'Bank Statement',
  OFAC: 'OFAC',
  ofac: 'OFAC' // backward compatibility
};

export const componentNamesActual = {
  Education: 'Education',
  Address: 'Address',
  DigitalAddress: 'DigitalAddress',
  CompanyCheck: 'CompanyCheck',
  Criminal: 'Criminal',
  CreditCheck: 'CreditCheck',
  CibilCheck: 'CibilCheck',
  CvValidation: 'CvValidation',
  DatabaseCheck: 'DatabaseCheck',
  DirectorshipCheck: 'DirectorshipCheck',
  DrugTest: 'DrugTest',
  Employment: 'Employment',
  GapVerification: 'GapVerification',
  Identification: 'Identification',
  PoliceVerification: 'PoliceVerification',
  Reference: 'Reference',
  SocialMedia: 'SocialMedia',
  UanCheck: 'UanCheck',
  BankStatement: 'BankStatement',
  OFAC: 'OFAC'
};

export const statusArray = ['Awaiting', 'Work in progress', 'UnableToVerify', 'Discrepancy', 'Completed', 'Insufficient', 'BgvStop'];

export const panelArray = ['4 panel', '5 panel', '6 panel', '7 panel', '8 panel', '9 panel', '10 panel', '11 panel', '12 panel', '14 panel', '16 panel', '18 panel'];

export const contactRelationshipArray = ['Friend', 'Colleague', 'Others'];

export const labelTexts = {
  ClearInsufficiencyButton: 'Clear Insuff.'
};

export const CommonNames = {
  Save: 'Save',
  Saved: 'Saved',
  Clear: 'Clear',
  SaveDetails: 'Save Details',
  Initiate: 'Initiate',
  Initiated: 'Initiated',
  ReInitiate: 'Re-initiate',
  ResendSms: 'Resend SMS',
  GenerateReport: 'Generate Report',
  GenerateDigitalAddressReport: 'Generate DAV Report',
  DownloadDigitalAddressReport: 'Download DAV Report',
  Verify: 'Verify',
  SubmitVerification: 'Submit Verification',
  Confirm: 'Confirm',
  ConfirmIndivDAV: 'Confirm Verification',
  CurrentStatus: 'Current Status',
  Filter: 'Filter',
  ClientFilter: 'Client filter',
  TagsFilter: 'Tags Filter',
  InvoiceFilter: "Invoice Filter",
  Apply: "Apply",
  ClientName: "Client Name",
  Update: "Update",
  SelectClient: "Select a client",
  SelectMonth: "Select a month",
  SelectYear: "Select a year",
};

export const DigitalAddressNames = {
  PermanentAddress: 'Permanent Address',
  CurrentAddress: 'Current Address',
  IntermediateOneAddress: 'Intermediate 1 Address',
  IntermediateTwoAddress: 'Intermediate 2 Address',
  CandidateInfo: 'Candidate Information',
  FCTno: 'FCT No',
  CandidateName: 'Candidate Name',
  MobileNo: 'Mobile Number',
  RespondantName: 'Respondent Name',
  RespondantMobile: 'Respondent Mobile',
  RespondantRelationship: 'Respondent Relationship',
  RespondantIdProof: 'Respondent ID proof',
  OtherRelationship: 'Enter relationship',
  OtherRelationshipPlaceholder: 'ex. Uncle, Nephew, etc',
  LatLong: 'Latitude and Longitude',
  GetLocationBtn: 'Get Location',
  Address: 'Address',
  PeriodOfStay: 'Period of stay',
  PeriodOfStayPlaceholder: 'ex. 2 years, etc',
  Ownership: 'Ownership',
  OtherOwnership: 'Enter Ownership',
  VerificationDate: 'Verification Date',
  CaptureSelfie: 'Capture Selfie',
  CaptureLocation: 'Capture Location Image',
  CaptureLandmark: 'Capture Landmark Image',
  ReCaptureSelfie: 'Re-Capture Selfie',
  ReCaptureLocation: 'Re-Capture Location Image',
  ReCaptureLandmark: 'Re-Capture Landmark Image',
  Signature: 'Signature',
  SubmitVerification: 'Submit Verification',
  Respondant: 'Respondant',
  DeviceLocation: 'Device Location',
  AddressLocation: 'Address Location',
  RespondantComment: 'Additional Comments',
  DownloadDAVReportButton: 'Download digital address verification report'
};

export const InvoiceNames = {
  InvoiceStartDate: "Invoice Start Date",
  InvoiceEndDate: "Invoice End Date",
  Invoices: "Billing Components",
  HoldDatas: "Components on Hold",
  InvoiceSummaryDetails: "Invoice Summary Details",
  InvoiceTrackerDetails: "Invoice Tracker Details",
  componentsOnHold: "Components On Hold",
  InvoicesForTheMonth: "Invoices For the Month",
}

export const ClientFormNames = {
  "SelectClientAddressState": "Select Client Address State",
  "SelectBillingAddressState": "Select Billing Address State"
}

export const ClientPricingFormNames = {
  Price: "Price",
  AdditionalCost: "Additional Cost",
  PricingPending: "Pricing pending",
  PriceAdded: "Price added",
}